import { useState } from 'react'
import { useSystemSkillStore } from '../../../../stores/systemSkillStore'
import { SkillDatabaseList } from './SkillDatabaseList'
import { SkillDatabaseEditor } from './SkillDatabaseEditor'

export function SkillDatabaseTab() {
  const { databases, getDatabase } = useSystemSkillStore()
  const [selectedDatabaseId, setSelectedDatabaseId] = useState<string | null>(null)

  const selectedDatabase = selectedDatabaseId ? getDatabase(selectedDatabaseId) : null

  if (selectedDatabase) {
    return (
      <SkillDatabaseEditor
        database={selectedDatabase}
        onBack={() => setSelectedDatabaseId(null)}
      />
    )
  }

  return (
    <SkillDatabaseList
      onSelectDatabase={setSelectedDatabaseId}
      selectedDatabaseId={selectedDatabaseId}
    />
  )
}
